import { useEffect, useState } from "react"
import MultiImagesView from "./MultiimagesView"
import { PublishedAsset } from "@ncs/ncs-api/src/portal-apps/point-of-sale/types"

export type Image = {
	id: string
	image: string
	alt: string
	type: "image" | "360" | "video"
}

type MultiImagesProps = {
	assets: PublishedAsset[] | undefined
	isLoading: boolean
	partName: string
}

const MultiImages: React.FC<MultiImagesProps> = ({ assets, isLoading, partName = "" }) => {
	const [selectedAsset, setSelectedAsset] = useState<string | null>(null)
	const [isOpen, setIsOpen] = useState(false)

	const handleThumbnailClick = (id: string) => {
		setSelectedAsset(id)
	}
	const handleExpand = (asset: PublishedAsset) => {
		setSelectedAsset(asset.id.toString())
		setIsOpen(true)
	}

	useEffect(() => {
		setSelectedAsset(assets?.[0]?.id.toString() ?? null)
	}, [assets])

	if (!assets || isLoading || !selectedAsset) return null

	return (
		<MultiImagesView
			assets={assets}
			onExpand={handleExpand}
			onClose={() => {
				setIsOpen(false)
			}}
			selectedAsset={selectedAsset ?? ""}
			isOpen={isOpen}
			onAssetClick={handleThumbnailClick}
			isLoading={isLoading}
			partName={partName}
		/>
	)
}

export default MultiImages
